<template>
  <div class="bdy_top">
    <!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->
    <div class="table_list">
      <button class="table_button" @click="pushupdate">新增账号</button>
      <div class="table_list_button">
        <h1>账号列表</h1>
      </div>

      <el-table
        :fit="false"
        border
        :data="tableData"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>

        <el-table-column label="用户名">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="头像">
          <template slot-scope="scope">
            <img
              :src="scope.row.avatar || $userList.image_url + '/avatar.png'"
              style="width: 50px; height: 50px"
            />
          </template>
        </el-table-column>
        <el-table-column label="账号" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.user_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" width="200px">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.gender }}</span>
          </template>
        </el-table-column>

        <el-table-column label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.gender }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" min-width="400">
          <template slot-scope="scope">
            <el-tag
              v-for="item in scope.row.user_roles"
              :key="item.name"
              closable
              @close="getDelete(item)"
            >
              <span>{{ item.role.name }}/ 所属门店:{{ item.shop.name }}</span>
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="400px">
          <template slot-scope="scope">
            <el-button size="mini" @click="detailedInfo(scope.row)"
              >详细信息</el-button
            >
            <el-button size="mini" @click="detailedInfo_js(scope.row)"
              >角色新增</el-button
            >
            <el-button size="mini" @click="detailedInfo_pass(scope.row)"
              >修改密码</el-button
            >
            <el-button size="mini" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageSize"
        class="pagination_em"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog title="账号信息" :visible.sync="dialogFormVisible">
      <el-form :model="user" :rules="rules" ref="user">
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
          <el-input v-model="user.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth" prop="gender">
          <el-select v-model="user.gender" placeholder="请选择">
            <el-option label="男" :value="'男'"></el-option>
            <el-option label="女" :value="'女'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="账号"
          :label-width="formLabelWidth"
          prop="user_name"
        >
          <el-input v-model="user.user_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          :label-width="formLabelWidth"
          prop="passwd"
          v-if="!user.putStatus"
        >
          <el-input v-model="user.passwd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="联系方式"
          :label-width="formLabelWidth"
          prop="mobile"
        >
          <el-input v-model="user.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="头像" :label-width="formLabelWidth" prop="avatar">
          <el-upload
            :action="'https://upload-z2.qiniup.com'"
            list-type="picture-card"
            :auto-upload="true"
            :file-list="fileList"
            :on-success="topSuccess"
            :on-error="topSuccess"
            :before-upload="QiniuToken"
            :data="QiniuData"
            :limit="1"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <!-- <el-form-item label="avatar" :label-width="formLabelWidth" prop="avatar">
          <el-input v-model="user.avatar" autocomplete="off"></el-input>
        </el-form-item>-->
        <el-form-item
          label="角色"
          :label-width="formLabelWidth"
          v-if="!user.putStatus"
        >
          <div
            style="display: flex; margin-bottom: 10px"
            v-for="item in user.user_roles"
            :key="item.id"
          >
            <el-form-item label="角色选择" :label-width="formLabelWidth">
              <el-select v-model="item.role_id" placeholder="请选择">
                <el-option
                  v-for="index in typeList"
                  :key="index.id"
                  :label="index.name"
                  :value="index.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属门店" :label-width="formLabelWidth">
              <el-select v-model="item.shop_id" placeholder="请选择">
                <el-option
                  v-for="index in shopList"
                  :key="index.id"
                  :label="index.name"
                  :value="index.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>
        <el-button
          style="margin-left: 50px"
          @click="pushRoles"
          v-if="!user.putStatus"
          >增加角色</el-button
        >
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noneFrom">取 消</el-button>
        <el-button type="primary" @click="statusStores('user')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="详细信息" :visible.sync="dialogFormVisible_info">
      <el-form :model="user" :rules="rules" ref="user">
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
          <el-input v-model="user.name" disabled autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth" prop="gender">
          <el-select v-model="user.gender" disabled placeholder="请选择">
            <el-option label="男" :value="'男'"></el-option>
            <el-option label="女" :value="'女'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="账号"
          :label-width="formLabelWidth"
          prop="user_name"
        >
          <el-input
            v-model="user.user_name"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系方式"
          :label-width="formLabelWidth"
          prop="mobile"
        >
          <el-input
            v-model="user.mobile"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="avatar"
          :label-width="formLabelWidth"
          prop="avatar"
        >
          <el-input
            v-model="user.avatar"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label-width="'0px'">
          <div
            style="margin-bottom: 10px"
            v-for="item in user.user_roles"
            :key="item.id"
          >
            <div style="display: flex; margin-bottom: 10px">
              <el-form-item label="账号角色" :label-width="formLabelWidth">
                <el-select v-model="item.role_id" placeholder="请选择" disabled>
                  <el-option
                    v-for="index in typeList"
                    :key="index.id"
                    :label="index.name"
                    :value="index.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属门店" :label-width="formLabelWidth">
                <el-select v-model="item.shop_id" placeholder="请选择" disabled>
                  <el-option
                    v-for="index in shopList"
                    :key="index.id"
                    :label="index.name"
                    :value="index.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>

            <el-form-item
              v-if="item.role"
              :label="(item.role && item.role.name + '权限') || '权限'"
              :label-width="formLabelWidth"
            >
              <el-tag
                v-for="items in item.role.role_actions"
                :key="items.id"
                style="margin-right: 10px"
              >
                <span>{{ items.role_object.display_name }}</span>
              </el-tag>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item
          label="创建时间"
          :label-width="formLabelWidth"
          prop="avatar"
        >
          <el-input
            v-model="user.created_at"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="更新时间"
          :label-width="formLabelWidth"
          prop="avatar"
        >
          <el-input
            v-model="user.updated_at"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noneFrom">取 消</el-button>
        <el-button type="primary" @click="noneFrom">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增角色" :visible.sync="dialogFormVisible_js">
      <el-form :model="role_user" :rules="rules" ref="role_user">
        <el-form-item
          label="所属门店"
          :label-width="formLabelWidth"
          prop="shop_id"
        >
          <el-select v-model="role_user.shop_id" placeholder="请选择">
            <el-option
              v-for="index in shopList"
              :key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="角色选择"
          :label-width="formLabelWidth"
          prop="role_id"
        >
          <el-select v-model="role_user.role_id" placeholder="请选择">
            <el-option
              v-for="index in typeList"
              :key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noneFrom">取 消</el-button>
        <el-button type="primary" @click="roleStores('role_user')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible_pass">
      <el-form :model="setpassword" :rules="rules" ref="setpassword">
        <el-form-item
          label="新密码"
          :label-width="formLabelWidth"
          prop="new_password"
        >
          <el-input
            v-model="setpassword.new_password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noneFrom">取 消</el-button>
        <el-button type="primary" @click="storesPass('setpassword')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';
export default {
  name: 'administrators',
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      dialogFormVisible_info: false,
      dialogFormVisible_js: false,
      dialogFormVisible_pass: false,
      setpassword: {},
      formLabelWidth: '120px',
      tableData: [],
      total: 0,
      page_no: 1,
      formInline: '',
      typeList: [],
      shopList: [],
      user: {
        user_roles: [{}],
      },
      role_user: {},
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',

      QiniuData: {
        // key: '', //图片名字处理
        token: '', //七牛云token
      },
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        gender: [
          { required: true, message: '性别不能为空', trigger: 'change' },
        ],
        shop_id: [
          { required: true, message: '门店不能为空', trigger: 'change' },
        ],
        role_id: [
          { required: true, message: '角色不能为空', trigger: 'change' },
        ],
        mobile: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' },
        ],
        passwd: [{ required: true, message: '密码不能为空', trigger: 'blur' }],

        new_password: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
        ],
        user_name: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
        ],
        avatar: [{ required: true, message: '头像不能为空', trigger: 'blur' }],
      },
    };
  },

  methods: {
    initUser() {
      this.user = {
        user_roles: [{}],
      };
      this.fileList = [];
    },
    noneFrom() {
      this.dialogFormVisible = false;
      this.dialogFormVisible_info = false;
      this.dialogFormVisible_js = false;
      this.dialogFormVisible_pass = false;

      this.initUser();
    },
    postRoles() {
      const url = this.$userList.user_user_list;
      if (!this.user.id) {
        let datas = this.user;
        if (!datas.user_roles.length) {
          this.$alert('角色不能为空');
          return;
        }
        datas.passwd = this.$sha256(datas.passwd);
        this.$http.post(url, datas).then((res) => {
          if (res.code === 200) {
            this.dialogFormVisible = false;
            this.initUser();
            this.getList();
            return;
          }
          if (res.code !== 200) {
            this.$alert(res.message);
          }
        });
      } else {
        let {
          id,
          user_name,
          name,
          gender,
          mobile,
          avatar,
          user_roles,
        } = this.user;
        const data = {
          id,
          user_name,
          name,
          gender,
          mobile,
          avatar,
          user_roles,
        };
        this.$http.put(url, data).then((res) => {
          if (res.code === 200) {
            this.dialogFormVisible = false;
            this.initUser();
            this.getList();
            return;
          }
          if (res.code !== 200) {
            this.$alert('修改失败');
          }
        });
      }
    },
    statusStores(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postRoles();
          console.log(this.user);
        } else {
          return false;
        }
      });
    },
    roleStores(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.$userList.user_user_role;
          this.$http.post(url, this.role_user).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '新增角色成功!',
              });
              this.dialogFormVisible_js = false;
              this.getList();
            } else {
              res.message && this.$alert(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    storesPass(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url =
            this.$userList.user_user_password + '/' + this.setpassword.id;
          const data = {
            old_password: this.setpassword.old_password,
            new_password: this.$sha256(this.setpassword.new_password),
          };
          this.$http.post(url, data).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '密码修改成功!',
              });
              this.dialogFormVisible_pass = false;
              this.getList();
            } else {
              res.message && this.$alert(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    pushRoles() {
      const data = this.user.user_roles;
      data.push({});
      this.user.user_roles = data;
    },
    getType() {
      const url = this.$userList.user_user_roles;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.typeList = res.data;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //获取门店
    getShop() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.shopList = res.data.items;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    getList() {
      const url = this.$userList.user_user_list + '/' + this.page_no + '/20';
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.total = res.data.count;
          this.tableData = res.data.items;
          console.log(this.tableData);
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    pageSize(index) {
      this.page_no = index;
      this.getList();
    },
    handleEdit(index) {
      const url = this.$userList.user_user_list + '/' + index.id;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.user = res.data;

          // this.user.putStatus = true;
          this.dialogFormVisible = true;
          this.fileList = [{ url: res.data.avatar }];
          return;
        }
        if (res.code !== 200) {
          this.$alert('获取信息失败');
        }
      });
    },
    detailedInfo(index) {
      const url = this.$userList.user_user_list + '/' + index.id;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          console.log('detail user', res.data);
          this.user = res.data;
          this.user.updated_at = fecha.format(
            new Date(this.user.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          this.user.created_at = fecha.format(
            new Date(this.user.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          console.log(this.user.created_at);
          this.dialogFormVisible_info = true;
          return;
        }
        if (res.code !== 200) {
          this.$alert('获取信息失败');
        }
      });
    },
    detailedInfo_js(index) {
      this.role_user = {};
      this.role_user.user_id = index.id;
      this.dialogFormVisible_js = true;
    },
    detailedInfo_pass(index) {
      this.setpassword = {};
      this.setpassword.id = index.id;
      this.setpassword.old_password = index.passwd;
      this.dialogFormVisible_pass = true;
    },
    pushupdate() {
      this.dialogFormVisible = true;
      this.initUser();
    },
    getDelete(item) {
      this.$confirm('此操作将删除子账号角色, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const url = this.$userList.user_user_role + '/' + item.id;
        this.$http.delete(url).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.getList();
          } else {
            res.message && this.$alert(res.message);
          }
          console.log(res);
        });
      });
    },
    // 七牛
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    topSuccess(event, file, fileList) {
      console.log(fileList);
      this.fileList = fileList.map((item) => {
        if (item.response) {
          item.name = item.response.hash;
          item.url = this.QiniuData.url_prefix + '/' + item.response.hash;
        }
        return item;
      });
      this.user.avatar = this.fileList[0].url;
    },
    async QiniuToken() {
      const url = this.$userList.user_status_qiniutoken_dish;
      const data = await this.$http.get(url).then((res) => {
        return res;
      });
      if (data.code === 200 && data.data.up_token) {
        this.QiniuData.token = data.data.up_token;
        this.QiniuData.url_prefix = data.data.url_prefix;
        return true;
      } else {
        return false;
      }
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter((item) => {
        if (item.name !== file.name) {
          return item;
        }
      });
      console.log(file);
    },
  },

  created() {
    this.getList();
    this.getType();
    this.getShop();
  },
};
</script>
<style lang="scss">
.bdy_top {
  width: 100%;
  height: auto;
}

.rili {
  width: 100%;
  height: auto;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
  font-size: 14px;
}
.rili .ul {
  width: 100%;
  border-top: solid 1px #eee;
  display: flex;
  justify-content: space-between;
  border-left: solid 1px #eee;
}
.rili .ul li {
  flex: 1;
  border-right: solid 1px #eee;
  min-height: 77px;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 10px;
  padding-top: 30px;
}
.rili .ul li span {
  position: absolute;
  right: 10px;
  top: 5px;
}
.rili .ul:last-child li {
  border-bottom: solid 1px #eee;
}
.back_r {
  display: flex;
}
.back_r li {
  flex: 1;
  text-align: end;
}
.prev,
.next {
  color: #c0c4cc;
}
.clickDate {
  background: #f2f8fe;
  color: #409eff;
}
.ceshi {
  flex: 1;
  height: 20px;
  opacity: 0.5;
  text-align: center;
}
.leftClass {
  box-sizing: border-box;
  margin-left: 10px;
  border-radius: 5px 0 0 5px;
}
.rightClass {
  box-sizing: border-box;
  margin-right: 10px;
  border-radius: 0 5px 5px 0;
}
.table_list {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.table_list_button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-table__body,
.el-table__header {
  width: 100% !important;
}
table,
tbody,
thead {
  width: 100% !important;
}
colgroup {
  position: absolute;
  width: 100% !important;
  display: flex;
}
col {
  flex: 1;
  text-align: center;
}
.table_button {
  width: 100px;
  height: 40px;
  border-radius: 10px;
  background: #409eff;
  color: #fff;
}
.role_style {
  display: flex;
  position: relative;
}
</style>
